module.exports = __webpack_public_path__ + "static/media/Bettdecke_140x200_Kissen_80x60.d9ebb4f7.png";